import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIdeal, IIdealInitialState } from "./idealModel";
import {
  ActiveInactiveIdeal,
  IdealImageUpload,
  createIdeal,
  deleteIdeal,
  getAllActiveIdeals,
  getAllIdeals,
  getIdealByID,
  updateIdeal,
} from "./services/ideal.services";

const initialState: IIdealInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  IdealID: null,
  IdealList: [],
  IdealDetail: {
    ID: null,
    PropertyID: null,
    Title: "",
    Description: "",
    IsActive: 1,
  },
};

const idealSlice = createSlice({
  name: "ideal",
  initialState,
  reducers: {
    clearIdealDetails: (state) => {
      state.IdealDetail = initialState.IdealDetail;
    },
    setIdealID: (state, action) => {
      state.IdealID = action.payload;
    },
    clearIdealID: (state) => {
      state.IdealID = initialState.IdealID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllIdeals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllIdeals.fulfilled,
      (state, action: PayloadAction<IIdeal[]>) => {
        state.loading = false;
        state.IdealList = action.payload || [];
      },
    );
    builder.addCase(getAllIdeals.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.IdealList = [];
    });
    builder.addCase(createIdeal.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createIdeal.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createIdeal.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateIdeal.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateIdeal.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateIdeal.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteIdeal.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteIdeal.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteIdeal.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getIdealByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getIdealByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.IdealDetail = action.payload;
    });
    builder.addCase(getIdealByID.rejected, (state, action) => {
      state.loading = false;
      state.IdealDetail = initialState.IdealDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveIdeals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveIdeals.fulfilled,
      (state, action: PayloadAction<IIdeal[]>) => {
        state.loading = false;
        state.IdealList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveIdeals.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.IdealList = [];
    });
    builder.addCase(ActiveInactiveIdeal.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveIdeal.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveIdeal.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(IdealImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(IdealImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(IdealImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearIdealDetails, clearIdealID, setIdealID } =
  idealSlice.actions;
export default idealSlice.reducer;
